(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["content-banner"]) return;
  try {
    

new Swiper('.swiper-content-banner', {
  loop: true,
  slidesPerView: 1,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  allowTouchMove: false,
  autoplay: {
    delay: 8000
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-collection-current-stock"]) return;
  try {
    

new Swiper('.swiper-content-collection-current-stock', {
  loop: true,
  spaceBetween: 16,
  slidesPerView: 1.25,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 1.75
    },
    1024: {
      slidesPerView: 2.75
    }
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-collection-custom"]) return;
  try {
    

new Swiper('.swiper-content-collection-custom', {
  loop: true,
  spaceBetween: 16,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    }
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-cta-collection-custom"]) return;
  try {
    

new Swiper('.swiper-container-content-cta-collection-custom', {
  loop: true,
  spaceBetween: 16,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 2
    },
    1024: {
      slidesPerView: 4
    }
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-gallery-apparel"]) return;
  try {
    

new Swiper('.swiper-content-gallery-apparel', {
  loop: true,
  spaceBetween: 16,
  slidesPerView: 1.25,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 1.75
    }
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-gallery-bikes"]) return;
  try {
    

new Swiper('.swiper-content-gallery-bikes', {
  loop: true,
  spaceBetween: 16,
  slidesPerView: 1.25,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 1.75
    },
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-gallery-parts"]) return;
  try {
    

new Swiper('.swiper-content-gallery-parts', {
  loop: true,
  spaceBetween: 16,
  slidesPerView: 1.25,
  centeredSlides: true,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  },
  breakpoints: {
    768: {
      slidesPerView: 1.75
    }
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-gallery-product-images"]) return;
  try {
    

new Swiper('.swiper-content-gallery-product-images', {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-image-with-text-about"]) return;
  try {
    

new Swiper('.swiper-content-image-with-text-about', {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-image-with-text-apparel"]) return;
  try {
    

new Swiper('.swiper-content-image-with-text-apparel', {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-image-with-text-bikes"]) return;
  try {
    

new Swiper('.swiper-content-image-with-text-bikes', {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-image-with-text-parts"]) return;
  try {
    

new Swiper('.swiper-content-image-with-text-parts', {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  }
})


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["content-meet-the-team"]) return;
  try {
    

new Swiper('.swiper-content-meet-the-team', {
  loop: true,
  slidesPerView: 1,
  navigation: {
    nextEl: '.swiper-next',
    prevEl: '.swiper-prev'
  }
})


  } catch(e) { console.error(e); }
})();

})();
